module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    ref: "textWrap",
    class: ['text-wrap', _vm.textWrapClosed ? '' : 'opened']
  }, [_c('div', {
    ref: "text",
    class: ['text', _vm.textClosed ? 'f-toe3' : '']
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.item.content) + "\n\t\t")])]), _vm._v(" "), _c('div', {
    class: ['toggle-wrap', _vm.showToggle ? '' : 'f-dn', _vm.textClosed ? 'closed' : 'opened']
  }, [_c('a', {
    staticClass: "toggle-btn",
    on: {
      "click": _vm.toggleText
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.textClosed ? '展开' : '收起'))]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd52c254!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/item-content.vue
// module id = 868
// module chunks = 2